import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import axios from "axios";
import Timer from "@/components/quiz/Timer.vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import { Component, Prop, Vue } from "vue-facing-decorator";
import QuizViewerLayout from "@/components/layout/QuizViewerLayout.vue";
import QuizViewerCarousel from "@/components/quiz/QuizViewerCarousel.vue";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import QuizPreamble from "@/components/quiz/QuizPreamble.vue";
import InformationDialog from "@/components/dialogs/NotificationDialog.vue";
import SurveyQuiz from "@/components/quiz/SurveyQuiz.vue";
import PollQuiz from "@/components/quiz/PollQuiz.vue";
let PollQuizPlayer = class PollQuizPlayer extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "quizId", void 0);
    _defineProperty(this, "pollResultsId", void 0);
    _defineProperty(this, "userAnswersIds", '');
    // comma separated
    _defineProperty(this, "isSpeachTemplate", void 0);
    _defineProperty(this, "canEdit", void 0);
    _defineProperty(this, "BASE_API_QUIZ", '/api/v2/quiz');
    _defineProperty(this, "activeStep", 0);
    _defineProperty(this, "quizAnswered", false);
    _defineProperty(this, "userRealtimeAnswersIds", null);
    _defineProperty(this, "pollQuestion", null);
    _defineProperty(this, "quizStatisticsData", null);
  }
  mounted() {
    this.getQuiz();
    if (this.userAnswersIds?.length) {
      this.userRealtimeAnswersIds = this.userAnswersIds.split(',').map(answerId => parseInt(answerId)) || null;
    }
    if (this.pollResultsId) {
      this.quizAnswered = true;
    }
  }
  onQuizAnswerChange(userAnswersIds) {
    this.userRealtimeAnswersIds = userAnswersIds;
  }
  getQuiz() {
    axios.get(`${this.BASE_API_QUIZ}/${this.quizId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const pollQuizQuestions = response.data.questions;
      if (pollQuizQuestions?.length) {
        this.pollQuestion = pollQuizQuestions[0];
      }
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    });
  }
  async saveAnswerAndDisplayResultPage() {
    try {
      if (!this.canEdit) {
        await this.saveUserAnswers();
      }
      this.quizAnswered = true;
      this.getPollQuizStatistics();
    } catch (e) {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    }
  }
  async saveUserAnswers() {
    await axios.put(`${this.BASE_API_QUIZ}/${this.quizId}/poll-quiz-answers`, {
      userAnswersIds: this.userRealtimeAnswersIds?.join(',')
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).catch(e => {
      throw new Error(e);
    });
  }
  getPollQuizStatistics() {
    axios.get(`${this.BASE_API_QUIZ}/poll-quiz-stats?quizId=${this.quizId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.quizStatisticsData = response.data;
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    });
  }
};
__decorate([Prop({
  required: true
})], PollQuizPlayer.prototype, "quizId", void 0);
__decorate([Prop({
  default: 0
})], PollQuizPlayer.prototype, "pollResultsId", void 0);
__decorate([Prop], PollQuizPlayer.prototype, "userAnswersIds", void 0);
__decorate([Prop({
  default: false
})], PollQuizPlayer.prototype, "isSpeachTemplate", void 0);
__decorate([Prop({
  default: false
})], PollQuizPlayer.prototype, "canEdit", void 0);
PollQuizPlayer = __decorate([Component({
  components: {
    PollQuiz,
    SurveyQuiz,
    QuizPreamble,
    QuizViewerCarousel,
    QuizViewerLayout,
    InformationDialog,
    Pagination,
    Navigation,
    Slide,
    Carousel,
    Timer,
    StandardButton
  }
})], PollQuizPlayer);
export default PollQuizPlayer;